/**
 * Utilitários para gerenciamento de tokens JWT
 */

/**
 * Verifica se o token JWT está expirado
 * @returns {boolean} true se o token está expirado ou não existe
 */
export function isTokenExpired() {
  const token = localStorage.getItem("token");
  const tokenExpiration = localStorage.getItem("tokenExpiration");

  if (!token || !tokenExpiration) {
    return true;
  }

  try {
    const expirationDate = new Date(tokenExpiration);
    const now = new Date();
    
    // Adiciona margem de segurança de 1 minuto antes da expiração real
    const safetyMargin = 60 * 1000; // 1 minuto em milissegundos
    const expirationWithMargin = new Date(expirationDate.getTime() - safetyMargin);
    
    return now >= expirationWithMargin;
  } catch (error) {
    console.error("Error checking token expiration:", error);
    return true;
  }
}

/**
 * Remove todos os dados de autenticação do localStorage
 */
export function clearAuthData() {
  localStorage.removeItem("token");
  localStorage.removeItem("tokenExpiration");
  localStorage.removeItem("isAdmin");
  localStorage.removeItem("user");
}

/**
 * Obtém o token JWT do localStorage
 * @returns {string|null} O token ou null se não existir
 */
export function getToken() {
  return localStorage.getItem("token");
}

/**
 * Verifica se há um token válido (não expirado)
 * @returns {boolean} true se há um token válido
 */
export function hasValidToken() {
  return !isTokenExpired();
}

